import React from "react";
import "./style.css";
import { Title } from "../Title";
import Media01 from "./images/media-01.jpg";
import Media02 from "./images/media-02.jpg";
import Media03 from "./images/media-03.jpg";

export const Media = ({ className, content }) => {
  const mediaImages = [
    { src: Media01, link: "#" },
    { src: Media02, link: "#" },
    { src: Media03, link: "#" },
  ];

  // Duplicar os logos para criar efeito de loop infinito
  const duplicatedMedia = [...mediaImages, ...mediaImages, ...mediaImages];

  return (
    <section
      id="multi-media"
      className={`multi-media ${className} position-relative detail-top`}
    >
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }

        .animate-scroll {
          animation: scroll 30s linear infinite;
          gap: 50px;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="container">
        <Title
          title={content.sections.media.title}
          description={content.sections.media.description}
        />
      </div>

      <div className="midia__list position-relative overflow-hidden">
        <div className="d-flex animate-scroll">
          {duplicatedMedia.map((item, index) => (
            <div className="multi-media__item position-relative" key={index}>
              <img key={index} src={item.src} alt="Media" className="" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
